import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route path changes.
 * Bypasses Lenis smooth-scroll for an instant jump.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // If Lenis is mounted, ask it to jump immediately so it stays in sync
        if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
            window.__lenis.scrollTo(0, { immediate: true, force: true });
        }
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        // Also try the document scrolling element for safety
        if (document.scrollingElement) {
            document.scrollingElement.scrollTop = 0;
        }
    }, [pathname]);
    return null;
}
